import { Svg } from "../../../utils/svgIcon";

import hamburgerSvg from "./sidebar-hamburger.svg";

export interface SidebarHamburgerProps {
    className?: string;
}

export function SidebarHamburger({ className }: SidebarHamburgerProps) {
    return <Svg src={hamburgerSvg} className={className} />;
}
